import { Component, OnInit, AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { DashboardService, VehicleJobListItemDto, LocationServiceDto, InTransitDto, LocationTypeDto, JourneyItemDto, ActiveDashboardRequest, DepotDto, ActiveDashboardResponse, LiveDashboardRequest, LiveDashboardResponse } from 'src/shared/service-proxies/service-proxies';
import { timer  } from 'rxjs';
import { PageHelperService } from '../helpers/page-helper.service';
import { PagebaseComponent } from '../pagebase/pagebase.component';
import { ApplicationStatusService } from '../services/application-status.service';
import { SummaryDataItemModel } from '../models/summary-data-item-model';
import { AuthService } from '../security/auth.service';
import { SessionStorageService } from '../services/session-storage.service';
import { CustomerSettings } from '../services/customer-settings-service';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { InTransitMapComponent } from '../widgets';

export enum DashboardMode {
  Normal = 1,
  Irregular = 2
}

export class DropDownListItem {
  id: string;
  name: string;
}

@Component({
  selector: 'app-dashboard-live-component',
  templateUrl: './dashboard-live.component.html',
  styleUrls: ['./dashboard-live.component.scss']
})
export class DashboardLiveComponent extends PagebaseComponent implements OnDestroy, OnInit {
  
  // Private variables
  irregularMovements: boolean = this.authService.isHeadOfficeUser();
  DashboardMode = DashboardMode;
  dashboardMode: DashboardMode = DashboardMode.Normal;
  vehicleJobs: VehicleJobListItemDto[]
  jobs: JourneyItemDto[]
  services: LocationServiceDto[]
  inTransit: InTransitDto[];
  locationTypes: LocationTypeDto[] = [{name: "Customer", id: "", classification: 0, colour: "#00c07f"},{name: "Depot", id: "", classification: 0, colour: "#2978ff"}];
  selectedVehicleType: null;
  selectedVehicleId: string[];
  selectedLocationId: string[];
  selectedDepotId: string[];  
  summaryData = [];

  customerVehicles: DropDownListItem[];
  customerLocations: DropDownListItem[];
  depots: DropDownListItem[];
  
  private dataRefreshTimer: any;
  private dataRefreshSubscription;
  private apiCall;viewModeForm = new UntypedFormGroup({
    viewMode: new UntypedFormControl('both')
  });
  showMode: string = "both";
  @ViewChild('inTransitMap') inTransitMap: InTransitMapComponent;

  // Public variables
  loading: boolean = true;

  // Constuctor
  constructor(
    private _dashboardService: DashboardService,
    private authService: AuthService,
    pageHelperService: PageHelperService,
    applicationStatusService: ApplicationStatusService,
    private sessionStorageService: SessionStorageService,
    private customerSettings: CustomerSettings) {
    super(pageHelperService, applicationStatusService, customerSettings, "Live Operations");

    console.log("Live operations initialising");
  }

  ngOnInit(): void {
      this.summaryData = this.getLoadingSummarries();
  }

  getLoadingSummarries() : SummaryDataItemModel[] {
    var items = [];
    var text = "";
    text = text.concat("\xa0");
    let blank: SummaryDataItemModel = {
      Title: text,
      Value: text
    };
    items.push(blank);
    items.push(blank);
    items.push(blank);
    return items;
  }

  ngOnDestroy() {
    this.unsubscribe()
  }

  unsubscribe() {
    if (this.dataRefreshSubscription) {
      this.dataRefreshSubscription.unsubscribe();
    }    
    if (this.apiCall) {
      this.apiCall.unsubscribe();
    }
    
    this.dataRefreshSubscription = null;
    this.apiCall = null;
    this.dataRefreshTimer = null;
  }

  setupTimer() {
    this.dataRefreshTimer = timer(60000);
    this.dataRefreshSubscription = this.dataRefreshTimer.subscribe(() => {
      if (!this.loading) {
        this.getData();
      }
    })
  }

  changeIrregularMovements(value) {
    this.reset();
    this.irregularMovements = value;
    this.sessionStorageService.setItem("dashboard-live-irregularMovements", this.irregularMovements.toString());
    this.getData();
  }

  reset() {
    this.jobs = [];
    this.inTransit = [];
    this.vehicleJobs = [];
    this.services = [];
    if (this.apiCall) {
      this.apiCall.unsubscribe();
    }
    if (this.dataRefreshSubscription) {
      this.dataRefreshSubscription.unsubscribe();
    }
  }

  showSlider() {
    return true;
  }

  // Get the view data
  getData() {
    this.loading = true;
    this.setIsLoading(this.loading);
    this.setIrregularMovements();

    if (!this.irregularMovements) {
      this.dashboardMode = DashboardMode.Normal
      var selectedVehicleType = JSON.parse(this.sessionStorageService.getItem("dashboard-active-selectedVehicleType"));
      this.selectedVehicleType = selectedVehicleType;
      var request = this.GetLiveDashboardRequest();
      this.apiCall = this._dashboardService.getLiveDashBoardData(request).subscribe(data => {
        this.locationTypes = data.locationTypes;
        this.inTransit = data.inTransit;
        this.vehicleJobs = data.vehicleJobs;
        this.services = data.services;
        this.summaryData = this.getSummaryData(data.milesDriven, data.numberOfServices, data.numberOfJobs);
        this.depots = this.getDepotList(data.depots);
        this.loading = false;
        this.loadListDataRegular(data);
        this.setIsLoading(this.loading);
        this.setupTimer();
        
      }, error => {
        debugger;
      });
    } else {
      this.dashboardMode = DashboardMode.Irregular
      var params: ActiveDashboardRequest = {
        customerId: this.pageHelperService.selectedCompanyId,
        startDate: null,
        blackboxId: [],
        locationId: [],
        depotId: [],
        onlyShowIrregularInfo: this.irregularMovements,
        returnAllRows: false
      };

      this.apiCall = this._dashboardService.getActiveDashBoardData(
        params
      ).subscribe(data => {
        this.locationTypes = data.locationTypes;
        this.jobs = data.jobs;
        this.services = data.services;
        this.inTransit = this.generateVehicleLocations(this.jobs);
        this.summaryData = this.getSummaryData(data.milesDriven, data.numberOfServices, data.numberOfJobs)
        this.depots = this.getDepotList(data.depots);
        this.loading = false;
        this.loadListDataIrregular(data);
        this.setIrregularMovements();
        this.setIsLoading(this.loading);
      }, error => {
        debugger;
      });
    }
  }


  loadListDataRegular(data: LiveDashboardResponse) {
    // Get list data from the provided data
    const vehicles: DropDownListItem[] = [];
    const locations: DropDownListItem[] = [];

    data.vehicleJobs.forEach(vehicle => {

      vehicle.jobs.forEach(job => {
        // Add locations
        if (job.fromLocationId != null) {
          if (!locations.find(l => l.id == job.fromLocationId)) {
            var location = new DropDownListItem()
            location.id = job.fromLocationId;
            location.name = job.fromLocation;
            locations.push(location)
          }
        }

        if (job.toLocationId != null) {
          if (!locations.find(l => l.id == job.toLocationId)) {
            var location = new DropDownListItem()
            location.id = job.toLocationId;
            location.name = job.toLocation;
            locations.push(location)
          }
        }

        // Add vehicles
        if (job.vehicleId != null) {
          if (!vehicles.find(l => l.id == job.vehicleId)) {
            var vehicle = new DropDownListItem()
            vehicle.id = job.vehicleId;
            vehicle.name = job.vehicleName;
            vehicles.push(vehicle)
          }
        }
      });
    });

    data.services.forEach(service => {
      // Add locations
      if (service.locationId != null) {
        if (!locations.find(l => l.id == service.locationId)) {
          var location = new DropDownListItem()
          location.id = service.locationId;
          location.name = service.locationName;
          locations.push(location)
        }
      }

      // Add vehicles
      if (service.vehicleId != null) {
        if (!vehicles.find(l => l.id == service.vehicleId)) {
          var vehicle = new DropDownListItem()
          vehicle.id = service.vehicleId;
          vehicle.name = service.vehicleName;
          vehicles.push(vehicle)
        }
      }
    });

    this.customerVehicles = vehicles.sort(function (a, b) {
      if (a.name < b.name) { return -1; }
      if (a.name > b.name) { return 1; }
      return 0;
    })

    this.customerLocations = locations.sort(function (a, b) {
      if (a.name < b.name) { return -1; }
      if (a.name > b.name) { return 1; }
      return 0;
    })

    this.setIrregularMovements();

    var selectedVehicleId = [];
    if (this.sessionStorageService.getItem("dashboard-active-selectedVehicleId")) {
      selectedVehicleId = JSON.parse(this.sessionStorageService.getItem("dashboard-active-selectedVehicleId"));
      this.selectedVehicleId = selectedVehicleId;
    }
    var selectedLocationId = [];
    if (this.sessionStorageService.getItem("dashboard-active-selectedLocationId")) {
      selectedLocationId = JSON.parse(this.sessionStorageService.getItem("dashboard-active-selectedLocationId"));
      this.selectedLocationId = selectedLocationId;
    }

    console.log(this.selectedVehicleId);
  }


  loadListDataIrregular(data: ActiveDashboardResponse) {
    // Get list data from the provided data
    const vehicles: DropDownListItem[] = [];
    const locations: DropDownListItem[] = [];

    data.jobs.forEach(job => {
      // Add locations
      if (job.fromLocationId != null) {
        if (!locations.find(l => l.id == job.fromLocationId)) {
          var location = new DropDownListItem()
          location.id = job.fromLocationId;
          location.name = job.fromLocation;
          locations.push(location)
        }
      }

      if (job.toLocationId != null) {
        if (!locations.find(l => l.id == job.toLocationId)) {
          var location = new DropDownListItem()
          location.id = job.toLocationId;
          location.name = job.toLocation;
          locations.push(location)
        }
      }

      // Add vehicles
      if (job.vehicleId != null) {
        if (!vehicles.find(l => l.id == job.vehicleId)) {
          var vehicle = new DropDownListItem()
          vehicle.id = job.vehicleId;
          vehicle.name = job.vehicleName;
          vehicles.push(vehicle)
        }
      }

    });

    data.services.forEach(service => {
      // Add locations
      if (service.locationId != null) {
        if (!locations.find(l => l.id == service.locationId)) {
          var location = new DropDownListItem()
          location.id = service.locationId;
          location.name = service.locationName;
          locations.push(location)
        }
      }

      // Add vehicles
      if (service.vehicleId != null) {
        if (!vehicles.find(l => l.id == service.vehicleId)) {
          var vehicle = new DropDownListItem()
          vehicle.id = service.vehicleId;
          vehicle.name = service.vehicleName;
          vehicles.push(vehicle)
        }
      }
    });

    this.customerVehicles = vehicles.sort(function (a, b) {
      if (a.name < b.name) { return -1; }
      if (a.name > b.name) { return 1; }
      return 0;
    })

    this.customerLocations = locations.sort(function (a, b) {
      if (a.name < b.name) { return -1; }
      if (a.name > b.name) { return 1; }
      return 0;
    })

    this.setIrregularMovements();

    var selectedVehicleId = [];
    if (this.sessionStorageService.getItem("dashboard-active-selectedVehicleId")) {
      selectedVehicleId = JSON.parse(this.sessionStorageService.getItem("dashboard-active-selectedVehicleId"));
      this.selectedVehicleId = selectedVehicleId;
    }
    var selectedLocationId = [];
    if (this.sessionStorageService.getItem("dashboard-active-selectedLocationId")) {
      selectedLocationId = JSON.parse(this.sessionStorageService.getItem("dashboard-active-selectedLocationId"));
      this.selectedLocationId = selectedLocationId;
    }

    console.log(this.selectedVehicleId);
  }
  setIrregularMovements() {
    var sessionItem = this.sessionStorageService.getItem("dashboard-live-irregularMovements");
    if (sessionItem) {
      this.irregularMovements = (sessionItem === 'true');
    }
  }

  getSummaryData(milesValue: number, servicesValue: number, jobsValue: number): SummaryDataItemModel[] {
    var items = [];
    let miles: SummaryDataItemModel = {
      Title: "Miles Driven",
      Value: Math.trunc(milesValue).toString()
    };
    items.push(miles);
    let services: SummaryDataItemModel = {
      Title: "Services",
      Value: servicesValue.toString()
    };
    items.push(services);
    let jobs: SummaryDataItemModel = {
      Title: "Journeys",
      Value: jobsValue.toString()
    };
    items.push(jobs);
    return items;
  }

  dropdownChanged(opened) {
    if (!opened) {
      this.getData();
    }
  }

  vehicleChange(newValue) {
    if (newValue.length > 0) {
      this.sessionStorageService.setItem("dashboard-active-selectedVehicleId", JSON.stringify(newValue));
    } else {
      this.sessionStorageService.removeItem("dashboard-active-selectedVehicleId")
    }
  }

  locationChange(newValue) {
    if (newValue.length > 0) {
      this.sessionStorageService.setItem("dashboard-active-selectedLocationId", JSON.stringify(newValue));
    } else {
      this.sessionStorageService.removeItem("dashboard-active-selectedLocationId")
    }
  }

  depotChange(newValue) {
    if (newValue.length > 0) {
      this.sessionStorageService.setItem("dashboard-active-selectedDepotId", JSON.stringify(newValue));
    } else {
      this.sessionStorageService.removeItem("dashboard-active-selectedDepotId")
    }
  }


  selectedVehicleTypeValueChange(event) {
    this.sessionStorageService.setItem("dashboard-active-selectedVehicleType", JSON.stringify(event));
    this.selectedVehicleType = event;
    this.getData();
  }

  getDepotList(depots: DepotDto[]): DropDownListItem[] {
    const depotlist: DropDownListItem[] = [];
    depots.forEach(element => {
      var depot = new DropDownListItem()
      depot.id = element.id;
      depot.name = element.name;
      depotlist.push(depot)
    });

    return depotlist;
  }

  generateVehicleLocations(jobs: JourneyItemDto[]): InTransitDto[] {
    
    const data: InTransitDto[] = [];
    
    jobs.forEach(job => {
      const item: InTransitDto = {
        vehicleId: job.vehicleId,
        vehicleName: job.vehicleName,
        fromLocationId: job.fromLocationId,
        fromLocationLatitude: job.fromLocationLatitude,
        fromLocationLongitude: job.fromLocationLongitude,
        fromLocationName: job.fromLocation,
        fromLocationTypeName: job.fromLocationTypeName,
        toLocationId: job.toLocationId,
        toLocationLatitude: job.toLocationLatitude,
        toLocationLongitude: job.toLocationLongitude,
        toLocationName: job.toLocation,
        toLocationTypeName: job.toLocationTypeName,
        alert: job.alert
      }

      data.push(item);
    });

    return data;
  }

  GetLiveDashboardRequest(): LiveDashboardRequest {
    this.setIrregularMovements();

    var selectedVehicleId = [];
    if (this.sessionStorageService.getItem("dashboard-active-selectedVehicleId")) {
      selectedVehicleId = JSON.parse(this.sessionStorageService.getItem("dashboard-active-selectedVehicleId"));
      this.selectedVehicleId = selectedVehicleId;
    }
    var selectedLocationId = [];
    if (this.sessionStorageService.getItem("dashboard-active-selectedLocationId")) {
      selectedLocationId = JSON.parse(this.sessionStorageService.getItem("dashboard-active-selectedLocationId"));
      this.selectedLocationId = selectedLocationId;
    }
    var selectedDepotId = [];
    if (this.sessionStorageService.getItem("dashboard-active-selectedDepotId")) {
      selectedDepotId = JSON.parse(this.sessionStorageService.getItem("dashboard-active-selectedDepotId"));
      this.selectedDepotId = selectedDepotId;
    }

    var selectedVehicleType = null;
    if (this.sessionStorageService.getItem("dashboard-active-selectedVehicleType")) {
      selectedVehicleType = JSON.parse(this.sessionStorageService.getItem("dashboard-active-selectedVehicleType"));
      this.selectedVehicleType = selectedVehicleType;
    }

    this.dashboardMode = this.irregularMovements ? DashboardMode.Irregular : DashboardMode.Normal;
    var params: ActiveDashboardRequest = {
      customerId: this.pageHelperService.selectedCompanyId,
      blackboxId: selectedVehicleId,
      locationId: selectedLocationId,
      depotId: selectedDepotId,
      onlyShowIrregularInfo: this.irregularMovements,
      returnAllRows: true,
      vehicleType: selectedVehicleType == null ? "" : selectedVehicleType
    };
    return params;
  }

  viewModeChange(e) {
    this.showMode = e.target.value;
    this.inTransitMap.invalidateMap();
  }
  
}
